import { Link } from 'react-router-dom';
import { formatDate } from '../utils/parseContent';
import './AdminPostList.css';

export function AdminPostList({ posts, loading, error }) {
  if (loading) {
    return (
      <div className="admin-post-list__loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-post-list__error text-sans">
        <p>Error loading posts: {error}</p>
      </div>
    );
  }

  if (!posts || posts.length === 0) {
    return (
      <div className="admin-post-list__empty">
        <p className="text-muted">No posts yet. Create your first post!</p>
      </div>
    );
  }

  return (
    <div className="admin-post-list">
      {posts.map((post) => (
        <div key={post.id} className="admin-post-list__item">
          <div className="admin-post-list__info">
            <span className="admin-post-list__date text-sans text-small text-muted">
              {formatDate(post.createdAt)}
            </span>
            <span
              className={`badge ${post.published ? 'badge-published' : 'badge-draft'}`}
            >
              {post.published ? 'Published' : 'Draft'}
            </span>
          </div>
          <h3 className="admin-post-list__title">
            {post.title || (
              <span className="text-muted">
                {post.content?.substring(0, 50)}...
              </span>
            )}
          </h3>
          <div className="admin-post-list__actions">
            <Link
              to={`/admin/edit/${post.id}`}
              className="btn btn-secondary text-sans text-small"
            >
              Edit
            </Link>
            {post.published && (
              <Link
                to={`/post/${post.id}`}
                className="btn btn-ghost text-sans text-small"
              >
                View
              </Link>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
